export default __webpack_public_path__ + "static/media/incubator-bg@1x.47afb688.webp";